<ng-container *transloco="let t; prefix: SHARED_TRANSLOCO_SCOPE">
  @if (authState() === "loading") {
    <div class="flex h-screen items-center justify-center">
      <span class="text-ds-content-primary">{{ t("COMMON.LOADING") }}...</span>
    </div>
  }
  @if (authState() === "unauthorized") {
    <div class="flex h-screen flex-col items-center justify-center gap-2">
      <p class="text-ds-content-primary">
        {{ t("COMMON.UNAUTHORIZED") }}
      </p>
      <a
        class="text-ds-content-tertiary hover:text-ds-content-tertiary-hovered hover:underline"
        [href]="getLoginUrl()"
        >{{ t("COMMON.LOGIN") }}</a
      >
    </div>
  }
  @if (authState() === "error") {
    <div class="flex h-screen items-center justify-center">
      <span class="text-ds-content-primary">{{ t("COMMON.ERROR") }}</span>
    </div>
  }
  @if (authState() === "ok" && !profileCheckPending()) {
    <router-outlet />
  }
  @if (authState() === "ok" && profileCheckPending()) {
    <div class="flex h-screen items-center justify-center">
      <ds-spinner testId="app-profile-check-spinner" />
    </div>
  }
</ng-container>
